import { createStore } from "vuex";
import { isTokenExpired } from "@/utils/authutils";
import alerts from "./module/alertModule";

/* eslint-disable */
const storedToken = localStorage.getItem("authToken") || "";
const savedStores = localStorage.getItem("allStores") || "";
const validToken =
  storedToken !== null &&
  storedToken !== "undefined" &&
  !isTokenExpired(storedToken)
    ? storedToken
    : "";

export default createStore({
  state: {
    user: validToken,
    userName: localStorage.getItem("userName") || "",
    selectedStore: localStorage.getItem("selectedStore") || "",
    allStores: savedStores ? JSON.parse(savedStores) : [] || [],
    storeUpdatedAt: null,
    endpoint: "http://localhost:3000",
    hasSeenWelcomeMessage: false,
    isStepOpen: false,
    isEmailVerified: JSON.parse(localStorage.getItem("emailVerified")) || false,
    hasUploadedProduct: false,
    isSocialMediaConnected: false,
    isMainAlert: false,
    isSubAlert: false,
    requiresSetup: false,
    domainActivationProgress: "",
    servicePlans: [],
    facebookIntergration: null,
    adCreation: {
      pageId: null,
      adAccountId: null,
    },
    userDetails: null,
    wallet: null,
    subscription: [],
    isAdmin: false,
    userReady: false,
  },
  getters: {
    isAuthenticated: (state) => !!state.user,
    hasSeenWelcomeMessage: (state) => state.hasSeenWelcomeMessage,
    isEmailVerified: (state) => state.isEmailVerified,
    hasUploadedProduct: (state) => state.hasSeenWelcomeMessage,
    isSocialMediaConnected: (state) => state.isSocialMediaConnected,
    requiresSetup: (state) => state.requiresSetup,
    selectedStore: (state) => state.selectedStore,
    servicePlans: (state) => state.servicePlans,
    userDetails: (state) => state.userDetails,
    wallet: (state) => state.wallet,
    subscription: (state) => state.subscription,
    allStores: (state) => state.allStores,
    isStepOpen: (state) => state.isStepOpen,
    facebookIntergration: (state) => state.facebookIntergration,
    isAdmin: (state) => state.isAdmin,
  },
  mutations: {
    setUserReady(state, ready) {
      state.userReady = ready;
    },
    setServicePlans(state, plans) {
      state.servicePlans = plans;
    },
    setIsAdmin(state, isAdmin) {
      state.isAdmin = isAdmin;
    },
    setFacebookData(state, payload) {
      state.facebookIntergration = payload;
    },
    clearFacebookData(state) {
      state.facebookIntergration = null;
    },
    setAdCreationAssets(state, payload) {
      state.adCreation = payload;
    },
    setDomainActivationProgress(state, progress) {
      state.domainActivationProgress = progress;
    },
    setUser(state, token) {
      if (isTokenExpired(token)) {
        console.log("Token is expired. Not setting user.");
        state.user = null;
        localStorage.removeItem("authToken");
      } else {
        if (token !== null || token !== "" || token !== "undefined") {
          state.user = token;
          localStorage.setItem("authToken", token);
        }
      }
    },
    clearUser(state) {
      state.user = null;
      state.userName = null;
      localStorage.removeItem("selectedStore");
      localStorage.removeItem("allStores");
      localStorage.removeItem("userName");
      localStorage.removeItem("authToken");
      sessionStorage.removeItem("authToken");
    },
    setEmailVerified(state, emailToken) {
      let emailNotVerified = !!emailToken;
      state.isEmailVerified = emailNotVerified;
      localStorage.setItem("emailVerified", emailNotVerified);
    },
    setUserName(state, userName) {
      state.userName = userName;
      localStorage.setItem("userName", userName);
    },
    setStores(state, stores) {
      state.allStores = stores;
      localStorage.setItem("allStores", JSON.stringify(stores));
    },
    setSelectedStore(state, value) {
      state.selectedStore = value;
      localStorage.setItem("selectedStore", JSON.stringify(value));
      state.storeUpdatedAt = Date.now();
    },
    setRequiresSetup(state, requiresSetup) {
      state.requiresSetup = requiresSetup;
    },
    setUserDetails(state, userDetails) {
      state.userDetails = userDetails;
    },
    setWallet(state, wallet) {
      state.wallet = wallet;
    },
    setSubscription(state, subscription) {
      state.subscription = subscription;
    },
    setHasSeenWelcomeMessage(state, hasSeen) {
      state.hasSeenWelcomeMessage = hasSeen;
    },
    setIsStepOpen(state, isOpen) {
      state.isStepOpen = isOpen;
    },
  },
  actions: {
    async initializeStore({ commit, dispatch, state }) {
      const storedStore = localStorage.getItem("selectedStore");

      commit(
        "setHasSeenWelcomeMessage",
        localStorage.getItem(`${state.user}welcomeMessage`)
      );

      commit("setIsStepOpen", localStorage.getItem(`${state.user}isStepOpen`));

      if (storedStore) {
        commit("setSelectedStore", JSON.parse(storedStore));
        await dispatch("getIsUserAdmin");
      }
      // If user is authenticated, fetch user details and stores
      if (state.user) {
        await dispatch("fetchUserDetails");
      }
    },
    async onUserLogin({ dispatch }) {
      // Fetch all user-related data after login
      await dispatch("fetchUserDetails");
    },

    async createAds({ state }) {
      try {
        const response = await fetch("/api/facebook/create-ad", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id }),
        });

        const data = await response.json();

        if (response.ok) {
          return {
            success: true,
            message: data.message,
            ad: data.ad,
          };
        } else {
          console.error("Failed to create ad:", data.error);
          return {
            success: false,
            error: data.error || "Failed to create ad",
          };
        }
      } catch (error) {
        console.error("Error creating ad:", error);
        return { success: false, error: "Server error" };
      }
    },

    async buyDomain({ state }, payload) {
      try {
        const response = await fetch("/api/store/buyDomain", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id, ...payload }),
        });

        const data = await response.json();

        if (response.ok) {
          return data;
        } else {
          return {
            success: false,
            error: data.error || "Failed to buy domain",
          };
        }
      } catch (error) {
        console.error("Error buying domain:", error);
        return { success: false, error: "Server error" };
      }
    },

    async searchDomain({ state }, payload) {
      try {
        const response = await fetch("/api/store/searchDomains", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (response.ok) {
          return data;
        } else {
          console.error("Failed to search domains:", data.error);
          return {
            success: false,
            error: data.error || "Failed to search domains",
          };
        }
      } catch (error) {
        console.error("Error searching domains:", error);
        return { success: false, error: "Server error" };
      }
    },

    async saveFacebookIntegration({ commit, state }, integrationData) {
      try {
        const response = await fetch("/api/facebook/save-integration", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({
            storeId: state.selectedStore.id,
            ...integrationData,
          }),
        });

        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.message || "Failed to save integration");
        }
        commit("setFacebookData", data.data);
        return { success: true, data };
      } catch (error) {
        console.error("Error saving Facebook integration:", error);
        return { success: false, message: error.message };
      }
    },

    async updateDefault({ state }, payload) {
      try {
        const response = await fetch("/api/facebook/update-default", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id, ...payload }),
        });
        const data = await response.json();
        if (response.ok) {
          return { success: true, data };
        } else {
          return {
            success: false,
            error: data.error || "Failed to update default settings",
          };
        }
      } catch (error) {
        console.error("Error updating default settings:", error);
        return { success: false, error: "Server error" };
      }
    },

    async getFacebookData({ state }) {
      try {
        const response = await fetch("/api/facebook/get-facebook-data", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id }),
        });
        const data = await response.json();
        if (response.ok) {
          return { success: true, data };
        } else {
          return {
            success: false,
            error: data.error || "Failed to fetch Facebook data",
          };
        }
      } catch (error) {
        console.error("Error fetching Facebook data:", error);
        return { success: false, error: "Server error" };
      }
    },

    async getDefault({ state }) {
      try {
        const response = await fetch("/api/facebook/get-default", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id }),
        });
        const data = await response.json();
        if (response.ok) {
          return { success: true, data };
        } else {
          return {
            success: false,
            error: data.error || "Failed to get default settings",
          };
        }
      } catch (error) {
        console.error("Error fetching default settings:", error);
        return { success: false, error: "Server error" };
      }
    },

    async exchangeToken({ state }, payload) {
      try {
        const response = await fetch("/api/facebook/exchange-token", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify(payload),
        });
        const data = await response.json();
        if (response.ok) {
          return data;
        } else {
          return {
            success: false,
            error: data.error || "Failed to exchange token",
          };
        }
      } catch (error) {
        console.error("Error fetching daily sales data:", error);
        return { success: false, error: `Server error: ${error}` };
      }
    },
    async addStaff({ state }, payload) {
      try {
        const response = await fetch("/api/store/add-staffs", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({
            emails: payload,
            storeID: state.selectedStore.id,
          }),
        });
        const data = await response.json();
        if (response.ok) {
          return { success: true, message: data.message };
        } else {
          return {
            success: false,
            error: data.message || "Failed to update staff",
          };
        }
      } catch (error) {
        console.error("Error fetching daily sales data:", error);
        return { success: false, error: "Server error" };
      }
    },

    async fetchDailyBusinessOverview({ state }) {
      try {
        const response = await fetch("/api/product/dailySales", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id }),
        });

        const data = await response.json();
        if (response.ok) {
          return { success: true, data };
        } else {
          console.error("Failed to fetch daily sales data:", data.error);
          return {
            success: false,
            error: data.error || "Failed to fetch data",
          };
        }
      } catch (error) {
        console.error("Error fetching daily sales data:", error);
        return { success: false, error: "Server error" };
      }
    },
    async getIsUserAdmin({ state, commit }) {
      if (!state.user) return;
      try {
        const response = await fetch("/api/store/isAdmin", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id }),
        });
        const data = await response.json();
        if (response.ok) {
          commit("setIsAdmin", data.isAdmin);
        } else {
          commit("setIsAdmin", false);
          console.error("Failed to fetch admin status:", data.error);
        }
      } catch (error) {
        console.error("Error checking admin status:", error);
        commit("setIsAdmin", false);
      } finally {
        commit("setUserReady", true);
      }
    },

    async fetchUserDetails({ state, commit }) {
      if (!state.user) return;
      try {
        const res = await fetch("/api/auth/me", {
          method: "GET",
          headers: {
            Authorization: `Bearer ${state.user}`,
          },
        });
        const data = await res.json();
        if (data.success) {
          commit("setUserDetails", data.user);
          commit("setWallet", data.wallet);
          commit("setSubscription", data.subscription);
        } else {
          commit("setUserDetails", null);
          commit("setWallet", null);
          commit("setSubscription", null);
        }
      } catch (error) {
        commit("setUserDetails", null);
        commit("setWallet", null);
        commit("setSubscription", null);
      }
    },
    async setSubscription(
      { state, commit, dispatch },
      { planId, duration, amount }
    ) {
      try {
        const response = await fetch("/api/wallet/subscriptions", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ plan: planId, duration, amount }),
        });
        const data = await response.json();
        if (response.ok) {
          commit("setSubscription", data.subscription);
          // Update user details and wallet after setting subscription
          if (state.user) {
            await dispatch("fetchUserDetails");
          }
          return { success: true, subscription: data.subscription };
        } else {
          console.error("Failed to set subscription:", data.error);
          return {
            success: false,
            error: data.error || "Failed to set subscription",
          };
        }
      } catch (error) {
        console.error("Error setting subscription:", error);
        return { success: false, error: "Failed to set subscription" };
      }
    },
    async updateUserProfile({ state, commit }, payload) {
      try {
        const res = await fetch("/api/auth/update-profile", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify(payload),
        });
        const data = await res.json();
        if (data.success) {
          commit("setUserDetails", data.user);
          return { success: true, message: data.message };
        } else {
          return { success: false, error: data.message };
        }
      } catch (error) {
        return { success: false, error: error.message };
      }
    },
    async updateProfileImage({ state, commit }, formData) {
      try {
        const res = await fetch("/api/auth/update-profile-image", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${state.user}`,
          },
          body: formData,
        });
        const data = await res.json();
        if (data.success) {
          commit("setUserDetails", data.user);
          return { success: true, imageUrl: data.user.image };
        } else {
          return { success: false, error: data.message };
        }
      } catch (error) {
        return { success: false, error: error.message };
      }
    },
    async fetchServicePlans({ commit }) {
      try {
        const response = await fetch("/api/service-plans");
        const data = await response.json();
        if (response.ok) {
          commit("setServicePlans", data);
          return { success: true, value: data };
        } else {
          console.error("Failed to fetch service plans:", data.error);
          return {
            success: false,
            error: data.error || "Failed to fetch service plans",
          };
        }
      } catch (error) {
        console.error("Error fetching service plans:", error);
        return { success: false, error: "Server error" };
      }
    },
    async addProduct({ state }, formData) {
      try {
        formData.append("storeID", state.selectedStore.id);
        const response = await fetch("/api/product/addProduct", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${state.user}`,
          },
          body: formData,
        });
        const data = await response.json();
        if (response.ok) {
          return { success: true, response: data };
        } else {
          return {
            success: false,
            response: data.error || "Unknown error occurred",
          };
        }
      } catch (error) {
        console.error("Error saving store settings:", error);
      }
    },
    async deleteProduct({ state }, productId) {
      try {
        const response = await fetch(
          `/api/product/deleteProduct/${productId}?storeID=${state.selectedStore.id}`,
          {
            method: "DELETE",
            headers: {
              Authorization: `Bearer ${state.user}`,
            },
          }
        );
        const data = await response.json();
        if (response.ok) {
          return { success: true, response: data };
        } else {
          return { success: false, response: data };
        }
      } catch (error) {
        console.error("Error deleting product:", error);
        return {
          success: false,
          error: "An error occurred while deleting the product.",
        };
      }
    },
    async updateProduct({ state }, formData) {
      try {
        formData.append("storeID", state.selectedStore.id);
        const response = await fetch("/api/product/updateProduct", {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${state.user}`,
          },
          body: formData,
        });
        const data = await response.json();
        if (response.ok) {
          return { success: true, response: data };
        } else {
          return {
            success: false,
            response: data.error || "Unknown error occurred",
          };
        }
      } catch (error) {
        console.error("Error saving store settings:", error);
      }
    },
    async addCollection({ state }, formData) {
      try {
        formData.append("storeID", state.selectedStore.id);
        const response = await fetch("/api/product/addCollections", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${state.user}`,
          },
          body: formData,
        });
        const data = await response.json();
        if (response.ok) {
          return { success: true, response: data.totalCollections };
        } else {
          return { success: false, response: data };
        }
      } catch (error) {
        console.error("Error saving store settings:", error);
      }
    },
    async saveStoreSettings({ state }, formData) {
      try {
        formData.append("storeID", state.selectedStore.id);
        const response = await fetch("/api/store/saveStoreSettings", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${state.user}`,
          },
          body: formData,
        });
        const data = await response.json();
        if (response.ok) {
          return { success: true, response: data };
        } else {
          return { success: false, response: data };
        }
      } catch (error) {
        console.error("Error saving store settings:", error);
      }
    },
    async saveGeneralSettings({ state }, formData) {
      try {
        formData.append("storeID", state.selectedStore.id);
        const response = await fetch("/api/store/saveGeneralSettings", {
          method: "POST",
          headers: {
            Authorization: `Bearer ${state.user}`,
          },
          body: formData,
        });
        const data = await response.json();
        if (response.ok) {
          return { success: true, response: data.message };
        } else {
          return { success: false, response: data.message };
        }
      } catch (error) {
        console.error("Error saving general settings:", error);
      }
    },
    async isUseremailVerified({ state, commit }) {
      try {
        const response = await fetch("/api/auth/checkEmailVerification", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
        });

        const data = await response.json();
        if (response.ok) {
          commit("setEmailVerified", data.emailVerification);
        } else {
          commit("setUser", "");
        }
      } catch (error) {
        console.error("Error logging in:", error);
      }
    },

    //Remove line
    async getStores({ state, commit }) {
      try {
        const response = await fetch("/api/store/getStores", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
        });

        const data = await response.json();
        if (response.ok) {
          commit("setStores", data.stores);
          console.log(data.stores);
        } else {
          console.error("Failed to get stores");
        }
      } catch (error) {
        console.error("Error getting store:", error);
      }
    },
    //End remove

    async getGeneralDetails({ state }) {
      try {
        const response = await fetch("/api/store/getGeneralDetails", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            value: data.storeDetails,
            currencies: data.currencies,
          };
        } else {
          console.error("Failed to get stores");
          return { success: false, error: "Failed to get store details" };
        }
      } catch (error) {
        console.error("Error getting store:", error);
        return { success: false, error: error };
      }
    },
    async getStoreDetails({ state }) {
      try {
        const response = await fetch("/api/store/getStoreDetails", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            value: data.storeDetails,
            themes: data.storeThemes,
            staffs: data.storeStaffs,
          };
        } else {
          console.error("Failed to get stores");
          return { success: false, error: "Failed to get store details" };
        }
      } catch (error) {
        console.error("Error getting store:", error);
        return { success: false, error: error };
      }
    },
    async getPaystackBanks({ state }) {
      try {
        const response = await fetch("/api/store/paystack-banks", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
        });
        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            banks: data,
          };
        }
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    },

    async createPaystackSubAccount({ state }, payload) {
      try {
        const response = await fetch("/api/store/create-paystack-subaccount", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();

        if (response.ok) {
          return {
            success: true,
            subaccountCode: data.subaccount_code,
            message: data.message,
          };
        } else {
          return {
            success: false,
            error: data.error || "Failed to create sub-account.",
          };
        }
      } catch (error) {
        console.error("Error creating Paystack sub-account:", error);
        return {
          success: false,
          error: "Server error. Please try again later.",
        };
      }
    },

    async resolveBankAccount({ state }, { accountNumber, bankCode }) {
      try {
        const response = await fetch("/api/store/resolve-bank-account", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({
            accountNumber,
            bankCode,
          }),
        });

        const data = await response.json();

        if (response.ok) {
          return {
            success: true,
            accountName: data.account_name,
          };
        } else {
          return {
            success: false,
            error: data.error || "Failed to resolve bank account.",
          };
        }
      } catch (error) {
        console.error("Error resolving bank account:", error);
        return {
          success: false,
          error: "Server error. Please try again later.",
        };
      }
    },
    async getProductCategory({ state }) {
      try {
        const response = await fetch("/api/product/getProductCategory", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            categories: data.categories[0],
          };
        } else {
          console.error("Failed to fetch categories:", data.error);
          return {
            success: false,
            error: data.error || "Failed to fetch categories",
          };
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
        return { success: false, error: "Server error" };
      }
    },
    async fetchProduct({ state }, productId) {
      try {
        const response = await fetch("/api/product/getProduct", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id, productId }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            product: data.product,
          };
        } else {
          console.error("Failed to fetch products:", data.error);
          return {
            success: false,
            error: data.error || "Failed to fetch products",
          };
        }
      } catch (error) {
        console.error("Error fetching products:", error);
        return { success: false, error: "Server error" };
      }
    },
    async addProductCategory({ state }, categories) {
      try {
        const response = await fetch("/api/product/addProductCategory", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({
            storeID: state.selectedStore.id,
            category: categories,
          }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            message: data.message,
            updatedCategories: data.categories,
          };
        } else {
          console.error("Failed to add category:", data.error);
          return {
            success: false,
            error: data.error || "Failed to add category",
          };
        }
      } catch (error) {
        console.error("Error adding category:", error);
        return { success: false, error: "Server error" };
      }
    },

    async getProductSize({ state }) {
      try {
        const response = await fetch("/api/product/getProductSizes", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            sizes: data.sizes[0],
          };
        } else {
          console.error("Failed to fetch sizes:", data.error);
          return {
            success: false,
            error: data.error || "Failed to fetch sizes",
          };
        }
      } catch (error) {
        console.error("Error fetching sizes:", error);
        return { success: false, error: "Server error" };
      }
    },
    async deleteDiscountDB({ state }, discountId) {
      console.log(discountId, "discountid");
      try {
        const response = await fetch("/api/product/deleteDiscount", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({
            discountId,
          }),
        });
        console.log(discountId);

        const data = await response.json();

        if (response.ok) {
          return { success: true };
        } else {
          return {
            success: false,
            error: data.error || "Failed to delete discount.",
          };
        }
      } catch (error) {
        console.error("Error deleting discount:", error);
        return { success: false, error: `Server error. ${error}` };
      }
    },

    async deleteCollectionDB({ state }, collectionId) {
      try {
        const response = await fetch("/api/product/deleteCollection", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({
            collectionId,
          }),
        });

        const data = await response.json();

        if (response.ok) {
          return { success: true };
        } else {
          return {
            success: false,
            error: data.error || "Failed to delete collection.",
          };
        }
      } catch (error) {
        console.error("Error deleting collection:", error);
        return { success: false, error: `Server error. ${error}` };
      }
    },

    async deleteCouponDB({ state }, couponID) {
      try {
        const response = await fetch(`/api/product/deleteCoupon`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({
            storeID: state.selectedStore.id,
            couponID,
          }),
        });

        const data = await response.json();

        if (response.ok && data.message) {
          return {
            success: true,
            message: data.message,
          };
        } else {
          console.error(
            "Failed to delete coupon:",
            data.error || "Unknown error"
          );
          return {
            success: false,
            error: data.error || "Failed to delete coupon",
          };
        }
      } catch (error) {
        console.error("Error deleting coupon:", error);
        return { success: false, error: "Server error" };
      }
    },

    async getDiscount({ state }) {
      try {
        const response = await fetch("/api/product/getDiscounts", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id }),
        });

        const data = await response.json();

        if (response.ok) {
          return {
            success: true,
            discounts: data.discounts || [],
            allProductId: data.allProductIds || [],
          };
        } else {
          console.error("Failed to fetch discounts:", data.error);
          return {
            success: false,
            error: data.error || "Failed to fetch discounts",
          };
        }
      } catch (error) {
        console.error("Error fetching discounts:", error);
        return { success: false, error: "Server error" };
      }
    },

    async getCoupon({ state }) {
      try {
        const response = await fetch("/api/product/getCoupons", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id }),
        });

        const data = await response.json();

        if (response.ok && Array.isArray(data.coupons)) {
          return {
            success: true,
            coupons: data.coupons,
          };
        } else {
          console.error(
            "Failed to fetch coupons:",
            data.error || "Unknown error"
          );
          return {
            success: false,
            error: data.error || "Failed to fetch coupons",
          };
        }
      } catch (error) {
        console.error("Error fetching coupons:", error);
        return { success: false, error: "Server error" };
      }
    },

    async fetchCurrency() {
      try {
        const response = await fetch("/api/store/currencies", {
          method: "GET",
        });

        if (!response.ok) {
          throw new Error("Failed to fetch currencies");
        }

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            currency: data.currencies,
          };
        } else {
          console.error("Failed to add discount:", data.error);
          return {
            success: false,
            error: data.error || "Failed to add discount",
          };
        }
      } catch (error) {
        console.error("Error fetching currencies:", error);
      }
    },

    async addCoupon({ state }, coupon) {
      try {
        const response = await fetch("/api/product/createCoupon", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({
            storeID: state.selectedStore.id,
            coupons: coupon,
          }),
        });

        const data = await response.json();

        if (response.ok && data.coupon) {
          return {
            success: true,
            message: data.message || "Coupon created successfully",
            coupon: data.coupon,
          };
        } else {
          console.error("Failed to add coupon:", data.error || "Unknown error");
          return {
            success: false,
            error: data.error || "Failed to add coupon",
          };
        }
      } catch (error) {
        console.error("Error adding coupon:", error);
        return { success: false, error: "Server error" };
      }
    },

    async addDiscount({ state }, discounts) {
      try {
        const response = await fetch("/api/product/createDiscount", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({
            storeID: state.selectedStore.id,
            discount: discounts,
          }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            message: data.message,
            discount: data.discount,
          };
        } else {
          console.error("Failed to add discount:", data.error);
          return {
            success: false,
            error: data.error || "Failed to add discount",
          };
        }
      } catch (error) {
        console.error("Error adding discount:", error);
        return { success: false, error: "Server error" };
      }
    },
    async addProductSize({ state }, sizes) {
      try {
        const response = await fetch("/api/product/addProductSize", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({
            storeID: state.selectedStore.id,
            size: sizes,
          }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            message: data.message,
            updatedSizes: data.sizes,
          };
        } else {
          console.error("Failed to add size:", data.error);
          return {
            success: false,
            error: data.error || "Failed to add size",
          };
        }
      } catch (error) {
        console.error("Error adding size:", error);
        return { success: false, error: "Server error" };
      }
    },
    async resendVerification({ state }) {
      try {
        const response = await fetch("/api/auth/resend-verification", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            message: data.message,
          };
        } else {
          console.log(data.message);
          return {
            success: false,
            message: data.message,
          };
        }
      } catch (error) {
        console.error("Error fetching products:", error);
        return {
          success: false,
          error: `Server error ${error}`,
          message: error,
        };
      }
    },
    async getProducts({ state }) {
      try {
        const response = await fetch("/api/product/getProducts", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            products: data.products,
            summary: data.summary,
          };
        } else {
          console.error("Failed to fetch products:", data.error);
          return {
            success: false,
            error: data.error || "Failed to fetch products",
          };
        }
      } catch (error) {
        console.error("Error fetching products:", error);
        return { success: false, error: "Server error" };
      }
    },

    async getCollection({ state }) {
      try {
        const response = await fetch("/api/product/getCollections", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            totalCollections: data.totalCollections,
            collections: data.collections,
          };
        } else {
          console.error("Failed to fetch total collections:", data.error);
          return {
            success: false,
            error: data.error || "Failed to fetch total collections",
          };
        }
      } catch (error) {
        console.error("Error fetching total collections:", error);
        return { success: false, error: "Server error" };
      }
    },
    // Fetch Order History
    async getOrderHistory({ state }) {
      try {
        const response = await fetch("/api/product/getOrderHistory", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeID: state.selectedStore.id }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            orders: data.orders,
          };
        } else {
          console.error("Failed to fetch order history:", data.error);
          return {
            success: false,
            error: data.error || "Failed to fetch order history",
          };
        }
      } catch (error) {
        console.error("Error fetching order history:", error);
        return { success: false, error: "Server error" };
      }
    },

    // Fetch Recent Orders
    async getRecentOrders({ state }) {
      try {
        const response = await fetch("/api/product/getRecentOrders", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeId: state.selectedStore.id }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            orders: data.orders,
          };
        } else {
          console.error("Failed to fetch recent orders:", data.error);
          return {
            success: false,
            error: data.error || "Failed to fetch recent orders",
          };
        }
      } catch (error) {
        console.error("Error fetching recent orders:", error);
        return { success: false, error: "Server error" };
      }
    },

    // Fetch Today's Orders
    async getTodaysOrders({ state }) {
      try {
        const response = await fetch("/api/product/getTodaysOrders", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeId: state.selectedStore.id }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            orders: data.orders,
          };
        } else {
          console.error("Failed to fetch recent orders:", data.error);
          return {
            success: false,
            error: data.error || "Failed to fetch recent orders",
          };
        }
      } catch (error) {
        console.error("Error fetching recent orders:", error);
        return { success: false, error: "Server error" };
      }
    },

    //Fetch Order Details
    async fetchOrderDetails({ state }, orderId) {
      let storeId = state.selectedStore.id;
      try {
        const response = await fetch("/api/product/fetchOrder", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ storeId, orderId }),
        });
        const data = await response.json();
        if (!data.orders.length) {
          return {
            success: false,
            message: "Order not found",
          };
        }
        if (response.ok) {
          return { success: true, data };
        } else {
          return { success: false, data };
        }
      } catch (error) {
        console.error("Error fetching store products:", error);
      }
    },

    // Fetch all customers
    async getAllCustomers({ state }) {
      try {
        const response = await fetch("/api/product/getAllCustomers", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeId: state.selectedStore.id }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            customers: data.customers,
          };
        } else {
          console.error("Failed to fetch customers:", data.error);
          return {
            success: false,
            error: data.error || "Failed to fetch customers",
          };
        }
      } catch (error) {
        console.error("Error fetching customers:", error);
        return { success: false, error: "Server error" };
      }
    },

    async getDeliveries({ state }) {
      try {
        const response = await fetch("/api/product/fetchDeliveries", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeId: state.selectedStore.id }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            deliveries: data.deliveries,
          };
        } else {
          console.error("Failed to fetch recent orders:", data.error);
          return {
            success: false,
            error: data.error || "Failed to fetch recent orders",
          };
        }
      } catch (error) {
        console.error("Error fetching deliveries:", error);
        return { success: false, error: "Server error" };
      }
    },

    // Fetch all Orders
    async getAllOrders({ state }) {
      try {
        const response = await fetch("/api/product/getAllOrders", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeId: state.selectedStore.id }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            orders: data.orders,
          };
        } else {
          console.error("Failed to fetch recent orders:", data.error);
          return {
            success: false,
            error: data.error || "Failed to fetch recent orders",
          };
        }
      } catch (error) {
        console.error("Error fetching recent orders:", error);
        return { success: false, error: "Server error" };
      }
    },

    // Save Custom Domain
    async onSaveCustomDomain({ state, commit }, payload) {
      try {
        const response = await fetch("/api/store/activate-domain", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({
            domain: payload.domain,
            storeID: state.selectedStore.id,
          }),
        });

        if (!response.ok) {
          return { success: false, error: "Failed to activate domain" };
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder();

        let progress = "";
        let done = false;

        while (!done) {
          const { value, done: streamDone } = await reader.read();
          done = streamDone;

          if (value) {
            progress += decoder.decode(value, { stream: true });

            // Split progress into individual messages
            const messages = progress.split("\n\n");
            for (const message of messages) {
              if (message.startsWith("data:")) {
                const jsonString = message.slice(5).trim();

                let update;
                try {
                  update = JSON.parse(jsonString);
                } catch (e) {
                  console.error("Failed to parse SSE JSON:", jsonString, e);
                  continue;
                }

                if (update.status === "failed") {
                  commit(
                    "setDomainActivationError",
                    update.message || "Domain activation failed."
                  );
                  throw new Error(
                    update.message || "Domain activation failed."
                  );
                }
                commit("setDomainActivationProgress", update.message);
              }
            }

            // Remove processed messages
            progress = progress.slice(progress.lastIndexOf("\n\n") + 2);
          }
        }

        return {
          success: true,
          message: "Domain activation completed successfully!",
        };
      } catch (error) {
        console.error("Error saving domain:", error);
        return {
          success: false,
          error: error || error.message || "Server error",
          details: null,
        };
      }
    },

    // Create Order
    async createOrder({ state }, orderData) {
      try {
        const response = await fetch("/api/product/createOrder", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({
            orderData: orderData,
            storeID: state.selectedStore.id,
          }),
        });

        const data = await response.json();
        if (response.ok) {
          return {
            success: true,
            order: data.order,
          };
        } else {
          console.error("Failed to create order:", data.error);
          return {
            success: false,
            error: data.error || "Failed to create order",
          };
        }
      } catch (error) {
        console.error("Error creating order:", error);
        return { success: false, error: "Server error" };
      }
    },

    async verifyEmailChange(_, { password, token }) {
      try {
        const response = await fetch("/api/auth/verify-email-change", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Platform-Check": "hisell-frontend",
          },
          body: JSON.stringify({ password, token }),
        });
        const data = await response.json();
        if (response.ok) {
          return data;
        } else {
          return data;
        }
      } catch (error) {
        return { success: false, error: error.message || "Server error." };
      }
    },

    async verifyStoreEmailChange(_, { password, token }) {
      try {
        const response = await fetch("/api/store/verify-email-change", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Platform-Check": "hisell-frontend",
          },
          body: JSON.stringify({ password, token }),
        });
        const data = await response.json();
        if (response.ok) {
          return { success: true, message: data.message };
        } else {
          return {
            success: false,
            message: data.message || "Verification failed.",
          };
        }
      } catch (error) {
        return { success: false, error: error.message || "Server error." };
      }
    },

    async login({ commit, dispatch }, { email, password, rememberme }) {
      try {
        const response = await fetch(`/api/auth/login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email, password, rememberme }),
        });

        const data = await response.json();

        if (response.ok) {
          commit("setUser", data.token);
          commit("setEmailVerified", data.emailVerification);
          commit("setUserName", data.userName);
          commit("setStores", data.stores);
          commit("setRequiresSetup", data.requiresSetup);

          if (data.stores && data.stores.length > 0) {
            let selectedStore;

            if (data.requiresSetup) {
              selectedStore = data.stores[0];
              if (selectedStore.store_name === "Default Store") {
                localStorage.removeItem("authToken");
              } else {
                commit(
                  "setRequiresSetup",
                  selectedStore.store_name === "Default Store"
                );
                const storedStore = localStorage.getItem("selectedStore");
                selectedStore = storedStore
                  ? JSON.parse(storedStore)
                  : data.stores[0];
              }
            } else {
              const storedStore = localStorage.getItem("selectedStore");
              selectedStore = storedStore
                ? JSON.parse(storedStore)
                : data.stores[0];
            }
            commit("setSelectedStore", selectedStore);
            await dispatch("getIsUserAdmin");
            localStorage.setItem(
              "selectedStore",
              JSON.stringify(selectedStore)
            );
          } else {
            console.warn("No stores available for the user.");
            commit("setSelectedStore", null);
            localStorage.removeItem("selectedStore");
          }

          await dispatch("onUserLogin");
          return { success: true, token: data.token };
        } else {
          console.error("Login failed:", data.message || data.error);
          return {
            success: false,
            error: data.message || data.error || "Login failed",
          };
        }
      } catch (error) {
        console.error("Error logging in:", error);
        return { success: false, error: error.message };
      }
    },

    async googleLogin({ commit, dispatch }, { id_token }) {
      try {
        const response = await fetch(`/api/auth/google-login`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id_token }),
        });

        const data = await response.json();
        console.log("fetched data", data);
        if (response.ok) {
          commit("setUser", data.token);
          commit("setEmailVerified", data.emailVerification);
          commit("setUserName", data.userName);
          commit("setStores", data.stores);
          commit("setRequiresSetup", data.requiresSetup);

          if (data.stores && data.stores.length > 0) {
            let selectedStore;

            if (data.requiresSetup) {
              selectedStore = data.stores[0];
              if (selectedStore.store_name === "Default Store") {
                localStorage.removeItem("authToken");
              } else {
                commit(
                  "setRequiresSetup",
                  selectedStore.store_name === "Default Store"
                );
                const storedStore = localStorage.getItem("selectedStore");
                selectedStore = storedStore
                  ? JSON.parse(storedStore)
                  : data.stores[0];
              }
            } else {
              const storedStore = localStorage.getItem("selectedStore");
              selectedStore = storedStore
                ? JSON.parse(storedStore)
                : data.stores[0];
            }
            commit("setSelectedStore", selectedStore);
            await dispatch("getIsUserAdmin");
            localStorage.setItem(
              "selectedStore",
              JSON.stringify(selectedStore)
            );
          } else {
            console.warn("No stores available for the user.");
            commit("setSelectedStore", null);
            localStorage.removeItem("selectedStore");
          }

          await dispatch("onUserLogin");
          return { success: true, token: data.token };
        } else {
          return { success: false, error: data.message || "Login failed" };
        }
      } catch (error) {
        console.error("Error logging in:", error);
        return { success: false, error: error.message };
      }
    },

    async submitDelivery({ state }, payload) {
      try {
        const storeId = state.selectedStore.id;

        const response = await fetch("/api/product/addDelivery", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({ storeId, payload }),
        });

        const data = await response.json();

        if (response.status === 409) {
          return {
            success: false,
            message: "This email is already registered for this store.",
          };
        }

        if (!response.ok) {
          throw new Error(data.message || "Failed to add delivery");
        }

        return { success: true, message: data.message, data: data.data };
      } catch (error) {
        console.error("Error submitting delivery:", error);
        return { success: false, message: error.message };
      }
    },

    async updateProcessing({ state }, orderId) {
      const storeId = state.selectedStore.id;
      try {
        const response = await fetch("/api/product/updateToProcessing", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ orderId, storeId }),
        });
        const data = await response.json();
        if (response.ok) {
          return { success: true, message: data.message };
        } else {
          return { success: false, message: data.message };
        }
      } catch (error) {
        console.error("Error confirming payment:", error);
        return false;
      }
    },

    async requestConfirmPayment({ state }, orderId) {
      const storeId = state.selectedStore.id;
      try {
        const response = await fetch("/api/product/confirmPayment", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ orderId, storeId }),
        });
        const data = await response.json();
        if (response.ok) {
          return { success: true, message: data.message };
        } else {
          return { success: false, message: data.message };
        }
      } catch (error) {
        console.error("Error confirming payment:", error);
        return false;
      }
    },

    async checkEmail(_, { email }) {
      try {
        const response = await fetch(`/api/auth/verify-email`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        });

        if (response.ok) {
          const data = await response.json();
          return data.exists;
        } else {
          return false;
        }
      } catch (error) {
        console.error("Error checking email:", error);
        return false;
      }
    },

    async verifyInvite(_, { token }) {
      try {
        const response = await fetch(`/api/store/verify-invite`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token }),
        });

        const data = await response.json();
        if (response.ok) {
          return { success: true, data };
        } else {
          console.error("Failed to fetch email:", response.statusText);
          return { success: false, message: data.message };
        }
      } catch (error) {
        console.error("Error checking email:", error);
        return {
          success: false,
          message: "An error occurred while verifying.",
        };
      }
    },

    logout({ commit }) {
      commit("clearUser");
    },
    async register(
      { dispatch },
      { name, email, password, staff, staff_token }
    ) {
      try {
        const response = await fetch(`/api/auth/register`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            name,
            email,
            password,
            staff,
          }),
        });

        const data = await response.json();
        if (response.ok) {
          if (staff_token) {
            const data = await dispatch("verifyInvite", { token: staff_token });
            return { success: true, data };
          }
          return { success: true, message: data.message };
        } else {
          return { success: false, message: data.message };
        }
      } catch (error) {
        console.error("Error logging in:", error);
        return { success: false, error: error.message };
      }
    },
    async googleSignUp({ commit, dispatch }, { payload, staff_token }) {
      try {
        const response = await fetch(`/api/auth/google-register`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ payload }),
        });

        const data = await response.json();
        if (response.ok) {
          if (staff_token) {
            await dispatch("verifyInvite", { token: staff_token });
          }
          commit("setUser", data.token);
          commit("setEmailVerified", data.emailVerification);
          commit("setUserName", data.userName);
          commit("setStores", data.stores);
          commit("setRequiresSetup", data.requiresSetup);

          if (data.stores && data.stores.length > 0) {
            let selectedStore;

            if (data.requiresSetup) {
              selectedStore = data.stores[0];
              if (selectedStore.store_name === "Default Store") {
                localStorage.removeItem("authToken");
              } else {
                commit(
                  "setRequiresSetup",
                  selectedStore.store_name === "Default Store"
                );
                const storedStore = localStorage.getItem("selectedStore");
                selectedStore = storedStore
                  ? JSON.parse(storedStore)
                  : data.stores[0];
              }
            } else {
              const storedStore = localStorage.getItem("selectedStore");
              selectedStore = storedStore
                ? JSON.parse(storedStore)
                : data.stores[0];
            }
            commit("setSelectedStore", selectedStore);
            await dispatch("getIsUserAdmin");
            localStorage.setItem(
              "selectedStore",
              JSON.stringify(selectedStore)
            );
          } else {
            console.warn("No stores available for the user.");
            commit("setSelectedStore", null);
            localStorage.removeItem("selectedStore");
          }
          return { success: true, token: data.token };
        } else {
          return { success: false, error: data.error || "Registration failed" };
        }
      } catch (error) {
        console.error("Error logging in:", error);
        return { success: false, error: error.message };
      }
    },
    async resetPassword(_, { email }) {
      try {
        const response = await fetch(`/api/auth/request-password-reset`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ email }),
        });

        const data = await response.json();
        if (response.ok) {
          return { success: true, message: data.message };
        } else {
          return { success: false, message: data.message };
        }
      } catch (error) {
        console.error("Error requesting password reset:", error);
        return { success: false, error: error.message };
      }
    },
    async createNewPassword(_, { password, token, id }) {
      try {
        const response = await fetch(`/api/auth/reset-password`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ password, token, id }),
        });

        const data = await response.json();
        if (response.ok) {
          return { success: true, message: data.message };
        } else {
          return { success: false, message: data.message };
        }
      } catch (error) {
        return { success: false, error: error.message };
      }
    },
    async fundWallet({ state, dispatch }, { amount, bonus }) {
      try {
        const res = await fetch("/api/wallet/initiate-funding", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
          body: JSON.stringify({
            amount: parseFloat(amount),
            bonus: parseFloat(bonus || 0),
          }),
        });
        const data = await res.json();
        if (!data.success) throw new Error(data.message);

        // 2. Open Paystack modal using email from backend
        const { payWithPaystack } =
          require("@/composables/usePaystack").usePaystack();
        return await new Promise((resolve, reject) => {
          payWithPaystack({
            key: data.publicKey,
            email: data.email,
            amount: parseFloat(data.amount),
            currency: "NGN",
            ref: data.reference,
            onSuccess: async (response) => {
              try {
                const verifyRes = await fetch("/api/wallet/verify-funding", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${state.user}`,
                  },
                  body: JSON.stringify({ reference: response.reference }),
                });
                const verifyData = await verifyRes.json();
                if (verifyData.success) {
                  dispatch("fetchUserDetails");
                  resolve({
                    success: true,
                    amount: parseFloat(amount),
                    bonus,
                    reference: response.reference,
                  });
                } else {
                  reject(
                    new Error(verifyData.message || "Verification failed.")
                  );
                }
              } catch (err) {
                reject(new Error("Verification error."));
              }
            },
            onClose: () => {
              fetch("/api/wallet/cancel-transaction", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${state.user}`,
                },
                body: JSON.stringify({ reference: data.reference }),
              });
              reject(new Error("Payment was closed without completing."));
            },
          });
        });
      } catch (err) {
        const message =
          typeof err === "string"
            ? err
            : err?.message || "An unknown error occurred during funding.";
        return { success: false, error: message };
      }
    },
    async fetchWalletTransactions({ state }) {
      try {
        const res = await fetch("/api/wallet/transactions", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${state.user}`,
          },
        });
        const data = await res.json();
        if (data.success && Array.isArray(data.transactions)) {
          return { success: true, transactions: data.transactions };
        } else {
          return {
            success: false,
            error: data.message || "Could not fetch transactions.",
          };
        }
      } catch (error) {
        return {
          success: false,
          error: error.message || "Could not fetch transactions.",
        };
      }
    },
  },
  modules: {
    alerts,
  },
});
